import {createFetchAllSlice} from "../genericCrudSlice";
import {getWalletsApi} from "../../api/entities/wallets";

export const fetchWalletsSlice = createFetchAllSlice('wallets', getWalletsApi);
export const {fetchAllEntities: fetchWallets} = fetchWalletsSlice;
export default fetchWalletsSlice.reducer;
